export class CentralWhatsappApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The numbers the caller's grant reaches (`whatsapp:view`), by country and status. */
    list(filter = {}) {
        const params = new URLSearchParams();
        if (filter.country !== undefined)
            params.set('country', filter.country);
        if (filter.status !== undefined)
            params.set('status', filter.status);
        const qs = params.toString();
        return this.client.request({ method: 'GET', path: `/v1/central/whatsapp/numbers${qs !== '' ? `?${qs}` : ''}`, auth: true });
    }
    /** One number with its credential badges and its audit. */
    get(numberId) {
        return this.client.request({ method: 'GET', path: `/v1/central/whatsapp/numbers/${encodeURIComponent(numberId)}`, auth: true });
    }
    /** Register a number (always PENDING; `whatsapp:manage` at its country, or its market). */
    register(input) {
        return this.client.request({ method: 'POST', path: '/v1/central/whatsapp/numbers', body: input, auth: true });
    }
    /** Edit a number under compare-and-set: `version` is the one the caller read (409 `WA_NUMBER_VERSION_CONFLICT` when it moved). */
    update(numberId, version, patch) {
        return this.client.request({ method: 'PATCH', path: `/v1/central/whatsapp/numbers/${encodeURIComponent(numberId)}`, body: { ...patch, version }, auth: true });
    }
    /** Set or rotate the secrets (write-only): the answer shows only what is configured. */
    setCredentials(numberId, input) {
        return this.client.request({ method: 'PUT', path: `/v1/central/whatsapp/numbers/${encodeURIComponent(numberId)}/credentials`, body: input, auth: true });
    }
    /** Activate (needs all three secrets), pause or retire a number, under compare-and-set. */
    setStatus(numberId, version, to) {
        return this.client.request({ method: 'POST', path: `/v1/central/whatsapp/numbers/${encodeURIComponent(numberId)}/status`, body: { to, version }, auth: true });
    }
    // ---- a conversation's WhatsApp channel ------------------------------------------------------------------------------------------
    /** The channel state of a WhatsApp conversation: the number, the contact, the 24 h window and every message's delivery (`conversation:read_body`). */
    conversation(conversationId) {
        return this.client.request({ method: 'GET', path: `/v1/service-center/conversations/${encodeURIComponent(conversationId)}/whatsapp`, auth: true });
    }
    /** Send an APPROVED template (the only message allowed outside the 24 h window). `interactionId` is the client's idempotency key. */
    sendTemplate(conversationId, input) {
        return this.client.request({ method: 'POST', path: `/v1/service-center/conversations/${encodeURIComponent(conversationId)}/whatsapp/templates`, body: input, auth: true });
    }
    /** Retry a failed send the provider called transient (bounded; then it is dead-lettered). */
    retry(conversationId, interactionId) {
        return this.client.request({ method: 'POST', path: `/v1/service-center/conversations/${encodeURIComponent(conversationId)}/whatsapp/messages/${encodeURIComponent(interactionId)}/retry`, auth: true });
    }
}
//# sourceMappingURL=central-whatsapp.js.map